module.exports = __webpack_public_path__ + "static/img/2.2246b2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/2.png
// module id = IFzP
// module chunks = 0